import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ButtonCardComponent } from '@finder/shared/components/button-card/button-card.component';
import { LoggerService } from '@wdpr/ra-angular-logger';

const CSS_CLASS = {
    one: 'one-card',
    two: 'two-card',
    three: 'three-card'
};
const CLASSNAME = 'FINDER-RELATED-ACTIVITIES --';

@Component({
    selector: 'finder-related-activities',
    templateUrl: './related-activities.component.html',
    styleUrls: ['./related-activities.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonCardComponent,
    ],
})
export class RelatedActivitiesComponent implements OnInit {

    @Input() relatedData: any;

    cardRows = [];
    multiRow = false;

    constructor(
        private logger: LoggerService
    ) { }

    ngOnInit() {
        switch (this.relatedData.data.length) {
            case 1:
                this.cardRows.push({
                    quantityClass: CSS_CLASS.one,
                    cards: this.relatedData.data
                });
                break;
            case 2:
                this.cardRows.push({
                    quantityClass: CSS_CLASS.two,
                    cards: this.relatedData.data
                });
                break;
            case 3:
                this.cardRows.push({
                    quantityClass: CSS_CLASS.three,
                    cards: this.relatedData.data
                });
                break;
            default:
                this.multiRow = true;
                this.generateRows(this.relatedData.data.slice());
                break;
        }
    }

    private generateRows(data) {
        const rowLayouts = {
            4: [3, 1],
            5: [3, 2],
            6: [3, 3],
            7: [3, 3, 1],
            8: [3, 3, 2],
            9: [3, 3, 3]
        };
        const layoutTemplate = rowLayouts[data.length];

        if (!layoutTemplate) {
            this.logger.warn(`${CLASSNAME} Unsupported card count: MAX: 9, CURRENT: ${data.length}`);

            return;
        }

        layoutTemplate.forEach(cardCount => {
            let quantityClass;

            if (cardCount === 1) {
                quantityClass = CSS_CLASS.one;
            } else if (cardCount === 2) {
                quantityClass = CSS_CLASS.two;
            } else {
                quantityClass = CSS_CLASS.three;
            }

            this.cardRows.push({
                quantityClass,
                cards: data.splice(0, cardCount)
            });
        });
    }
}
